// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/InviteYourColleague/Handlers/SetFieldValue";
import { InviteYourColleagueFormContext } from "@store/Library/Widgets/InviteYourColleague/InviteYourColleagueForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    fieldLabel = "fieldLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.fieldLabel]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    emailState: state.greif.components.inviteYourColleagueForm.fieldValues["email"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface EmailStyles {
    emailTextField?: TextFieldPresentationProps;
}

export const emailStyles: EmailStyles = {};

const styles = emailStyles;
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const Email: FC<Props> = ({ emailState, fields, setFieldValue }) => {
    const { isRequired, fieldLabel } = fields;
    const inviteYourColleagueFormContext = useContext(InviteYourColleagueFormContext);
    const [emailErrorMessage, setEmailErrorMessage] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        inviteYourColleagueFormContext.validators.email = validateEmail;
        if (email && (email !== "" || email !== undefined)) {
            validateEmail();
        }
    }, [email]);

    useEffect(() => {
        setEmail(emailState as string);
    }, [emailState]);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.email = validateEmail;
    }, [isRequired]);

    const validateEmail = () => {
        const errorMessage =
            isRequired && !email
                ? (translate(`${fieldLabel} is required`) as string)
                : !email || emailRegexp.test(String(email))
                ? ""
                : (siteMessage("ContactUsForm_EmailIsInvalidErrorMessage") as string);
        setEmailErrorMessage(errorMessage);
        return !errorMessage;
    };

    const emailChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const emailChangeOnBlur = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "email", value: event.target.value });
    };

    return (
        <TextField
            // eslint-disable-next-line spire/avoid-dynamic-translate
            label={translate(fieldLabel)}
            value={email || ""}
            onChange={emailChangeHandler}
            required={isRequired}
            type="email"
            error={emailErrorMessage}
            onBlur={emailChangeOnBlur}
            {...styles.emailTextField}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Email),
    definition: {
        displayName: "Email",
        group: constants.widgetGroup.inviteYourColleague,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.inviteYourColleague, constants.pageType.notificationPreferences],
        fieldDefinitions: [
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Your Colleague's Email",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
